import { render, staticRenderFns } from "./PeopleSatoshi.vue?vue&type=template&id=906ccf4a&scoped=true&"
import script from "./PeopleSatoshi.vue?vue&type=script&lang=js&"
export * from "./PeopleSatoshi.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSatoshi.vue?vue&type=style&index=0&id=906ccf4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906ccf4a",
  null
  
)

export default component.exports